module.exports = __webpack_public_path__ + "static/doc/spacestudio Introduction.48c7c33.pdf";